import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../AuthContext";
import { api } from "../api";

export function AdminChangePasswordPage() {
  const navigate = useNavigate();
  const { adminUser, adminLogin } = useAuth();
  const [current, setCurrent] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    if (password !== confirm) { setError("Passwords do not match."); return; }
    if (password.length < 8) { setError("Password must be at least 8 characters."); return; }
    setError(""); setLoading(true);
    try {
      await api.adminChangePassword({ current_password: current, new_password: password });
      // Re-login to get fresh token without must_change_password
      const data = await api.adminLogin({ email: adminUser.email, password });
      adminLogin(data.token, { email: data.email, name: data.name, roles: data.roles });
      navigate("/admin");
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="auth-shell">
      <div className="auth-panel-left">
        <div className="auth-brand">
          <img src="/logo.jpg" alt="Cow Town Redi Mix" />
          <div className="auth-brand-name">Admin Portal</div>
          <div className="auth-brand-tagline">CowTown Redi Mix — Staff Access Only</div>
        </div>
      </div>
      <div className="auth-panel-right">
        <div className="auth-form-wrap">
          <div className="auth-form-title">Set Your Password</div>
          <div className="auth-form-sub">
            Welcome, <strong>{adminUser?.name}</strong>! You must set a new password before continuing.
          </div>
          <div className="alert alert-info" style={{ fontSize: "0.85rem", marginBottom: 20 }}>
            Your account was set up with a temporary password. Please choose a secure password to continue.
          </div>
          {error && <div className="alert alert-error">{error}</div>}
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label className="form-label">Current (Temporary) Password</label>
              <input className="form-input" type="password" value={current}
                onChange={e => setCurrent(e.target.value)} required autoFocus />
            </div>
            <div className="form-group">
              <label className="form-label">New Password</label>
              <input className="form-input" type="password" value={password}
                onChange={e => setPassword(e.target.value)} required minLength={8}
                placeholder="Minimum 8 characters" />
            </div>
            <div className="form-group">
              <label className="form-label">Confirm New Password</label>
              <input className="form-input" type="password" value={confirm}
                onChange={e => setConfirm(e.target.value)} required minLength={8} />
            </div>
            <button className="btn btn-primary" style={{ width: "100%", justifyContent: "center" }}
              type="submit" disabled={loading}>
              {loading ? "Saving..." : "Set Password & Continue"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
